import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import type { ShipmentStatus } from '#/shared/api/generated/shipment/models'
import {
  getGetShipmentApiV1ShipmentsShipmentIdGetQueryKey,
  useUpdateShipmentApiV1ShipmentsShipmentIdPatch,
} from '#/shared/api/generated/shipment/theCargoShipment'
import { getApiErrorDetail } from '#/shared/lib/api/error-handler'
import { toast } from '#/shared/ui/sonner'

import { invalidateShipmentLists } from './invalidate-shipment-queries'

export function useMarkShipmentStatus() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const mutation = useUpdateShipmentApiV1ShipmentsShipmentIdPatch({
    mutation: {
      onSuccess: (response, variables) => {
        queryClient.setQueryData(
          getGetShipmentApiV1ShipmentsShipmentIdGetQueryKey(
            variables.shipmentId,
          ),
          response,
        )
        invalidateShipmentLists(queryClient)
        queryClient.invalidateQueries({
          queryKey: getGetShipmentApiV1ShipmentsShipmentIdGetQueryKey(
            variables.shipmentId,
          ),
        })
        toast.success(t('detailToolbar.markAsSuccess'))
      },
      onError: (error) => {
        toast.error(getApiErrorDetail(error) ?? t('detailToolbar.markAsError'))
      },
    },
  })

  return {
    markAs: (shipmentId: string, status: ShipmentStatus) => {
      if (mutation.isPending) return
      mutation.mutate({ shipmentId, data: { status } })
    },
    isPending: mutation.isPending,
  }
}
